export class CreatorInfoMissingProperty {
    public ObjectType!: string;
    public ObjectId!: string;
    public ObjectName!: string;
    public PropertyName!: string;
    public Value!: string;
}